/**
 * The URL segment the SYS-admin user management page lives at under the Clarity section:
 * `/clarity/admin` — Brain's own `/admin`.
 *
 * Shared for the same reason {@link CLARITY_INTEGRATIONS_ROUTE_SEGMENT} is: the page's route in
 * `@efficiently/client-feat-clarity-work` and the shell's user-menu link must agree on it, and
 * `type:util` is the one layer both may reach.
 */
export const CLARITY_ADMIN_ROUTE_SEGMENT = 'admin';
